import _cloneDeep from 'lodash/cloneDeep';

import { getPromoLotteries, getRemainPrizeAPI } from 'api/client';
import { UPDATE_TASK_PRIZE } from 'client/redux/modules/lotteryTasks';
import { lotteryRestShowTypes } from 'config/promoLotteryTypes';
import { setMGMReferral } from 'client/redux/modules/mgmReferral';
const UPDATE_PARTICIPANT = 'UPDATE_PARTICIPANT';

const reducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_PARTICIPANT:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default reducer;

export function updateParticipantRemainderFromApi() {
    return async (dispatch, getState) => {
        const {
            promo: { uuid: promoUUID },
            lotteryParticipant: { uuid: lotteryUUID, showRest, prizeLimited },
            flags: { isMgmShare, isMgmSelf },
            mgmReferral: {
                lotteryParticipant: { uuid: mgmLotteryUUID, mgmShowRest, mgmPrizeLimited } = {}
            },
            mgmRelation: { mgmMission: { uuid: mgmPromoUUID } = {} }
        } = getState();
        const currentLotteryUUID = Boolean(isMgmShare || isMgmSelf) ? mgmLotteryUUID : lotteryUUID;
        const currentShowRest = Boolean(isMgmShare || isMgmSelf) ? mgmShowRest : showRest;
        const currentPrizeLimited = Boolean(isMgmShare || isMgmSelf)
            ? mgmPrizeLimited
            : prizeLimited;
        const currentPromoUUID = Boolean(isMgmShare || isMgmSelf) ? mgmPromoUUID : promoUUID;
        if (
            Boolean(currentLotteryUUID) &&
            currentShowRest === lotteryRestShowTypes.SHOW_REMAIN_AMOUNT &&
            currentPrizeLimited
        ) {
            const {
                payload: { quantity: remainder }
            } = await getRemainPrizeAPI(currentPromoUUID, currentLotteryUUID);
            dispatch(updateParticipantRemainder(remainder));
        }
    };
}

export function updateParticipantRemainder(remainder = 0) {
    return {
        type: UPDATE_PARTICIPANT,
        payload: {
            remainder
        }
    };
}

// 更新所有獎品剩餘數量 (只有用在好禮自由選 結束領取 或 一鍵全領 時)
export function updateAllLotteryRemainder(isUseNormalEntry = true) {
    return async (dispatch, getState) => {
        try {
            const {
                lotteryParticipant: { uuid: lotteryParticipantUUID },
                lotteryTasks,
                promo: { uuid: promoUUID },
                flags: { isMgmShare, isMgmSelf },
                mgmRelation: { mgmReferral: { uuid: mgmPromoUUID } = {} },
                mgmReferral: {
                    lotteryParticipant: { uuid: mgmLotteryUUID } = {},
                    lotteryTasks: mgmLotteryTasks = {}
                }
            } = getState();
            const currentLotteryUUID =
                Boolean(isMgmShare) || (Boolean(isMgmSelf) && !isUseNormalEntry)
                    ? mgmLotteryUUID
                    : lotteryParticipantUUID;
            const currentLotteryTasks =
                Boolean(isMgmShare) || (Boolean(isMgmSelf) && !isUseNormalEntry)
                    ? mgmLotteryTasks
                    : lotteryTasks;
            const currentPromoUUID =
                Boolean(isMgmShare) || (Boolean(isMgmSelf) && !isUseNormalEntry)
                    ? mgmPromoUUID
                    : promoUUID;
            const { payload } = await getPromoLotteries(currentPromoUUID);
            const lotteryParticipant = payload.find(
                ({ lottery: { uuid } }) => uuid === currentLotteryUUID
            );

            if (lotteryParticipant) {
                const { prizeRemainder: remainder } = lotteryParticipant;
                dispatch({
                    type: UPDATE_PARTICIPANT,
                    payload: {
                        remainder
                    }
                });
            }

            const lotteryTasksRespond = payload.filter(({ lotterySetting: { Tasks } }) =>
                Boolean(Tasks)
            );
            const lotteryTasksCloned = _cloneDeep(currentLotteryTasks);
            lotteryTasksRespond.forEach(({ lottery: { uuid }, prizeRemainder }) => {
                if (lotteryTasksCloned[uuid]) {
                    lotteryTasksCloned[uuid].remainder = prizeRemainder;
                }
            });

            if (isUseNormalEntry) {
                dispatch({
                    type: UPDATE_TASK_PRIZE,
                    payload: lotteryTasksCloned
                });
            } else {
                dispatch(
                    setMGMReferral({
                        lotteryTasks: lotteryTasksCloned
                    })
                );
            }
        } catch (err) {
            console.log(err);
            return;
        }
    };
}
